// import { Link } from "react-router-dom";
import videoBg from "../../../assets/videos/ss-1.mp4";
import "./videoBg.css";
// import "../home.css";
// import banner from "../../../assets/images/home/pre-load.png";
import ReactPlayer from "react-player";
const VideoBg = () => {
  // if (!isLoaded) return <p style={{fontSize:'50px'}}>Loading images...</p>;
  return (
    <section className="home_video_main">
      <div className="video_container">
        <div className="video_overlay"></div>
        <div className="home-video-box">
          <ReactPlayer
            url={videoBg} // Replace with your video URL
            playing
            loop
            muted
            controls={false}
            width="100%"
            height="100%"
            playsinline
            preload="auto"
          />
        </div>
      </div>
    </section>
  );
};

export default VideoBg;
